import React, { useState } from "react";
import moment from "moment";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { registerUser, loginUser } from "../../../_actions/user_actions";
import { useDispatch } from "react-redux";
import { Form, Input, Button } from 'antd';
import FileUpload from '../../utils/FileUpload';
import AWS, { awsBucketName, deleteStoredImage } from '../../utils/S3Helper';
import Axios from "axios";
import styled from "styled-components";

const MyForm = styled(Form)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

let arrStoredImages = null;

function RegisterPage(props) {
  const state = props.location.state;
  const oldImageURL = state?.image;
  const dispatch = useDispatch();
  const [Images, setImages] = useState([]);

  const updateImages = (newImages) => {
    setImages(newImages)
  }

  return (

    <Formik
      initialValues={{
        email: state?.email || '',
        name: state?.name || '',
        phone: state?.phone || '',
        company: state?.company || '',
        password: state?.password || '',
        confirmPassword: state?.password || '',
        description: state?.description || '',
      }}

      validationSchema={Yup.object().shape({
        name: Yup.string()
          .required('이름을 입력해주세요'),
        email: Yup.string()
          .email('이메일 형식이 올바른지 확인해주세요')
          .required('이메일을 입력해주세요'),
        // phone: Yup.string()
        //   .required('전화번호를 입력해주세요'),
        password: state?.isModify ? Yup.string() : Yup.string() //개인정보 수정 기능을 위한 예외처리
          .min(6, '비밀번호는 6자 이상이어야 합니다')
          .required('비밀번호를 입력해주세요'),
        confirmPassword: state?.isModify ? Yup.string() : Yup.string()
          .oneOf([Yup.ref('password'), null], '비밀번호가 일치하지 않습니다')
          .required('확인을 위해 비밀번호를 한번더 입력해주세요')
      })}

      onSubmit={(values, { setSubmitting }) => {

        let arrPromise = Images.map(file => {
          return new AWS.S3.ManagedUpload({
            params: {
              Bucket: awsBucketName,
              Key: `profile/${values.email.replaceAll('@', '_')}/profile_${Date.now()}`,
              Body: file,
              ContentType: file.type,
            },
          }).promise();
        });

        setTimeout(() => {

          Promise.all(arrPromise).then(arrResponse => {
            arrStoredImages = arrResponse.map(data => data.Location);

            let dataToSubmit = {
              ...values,
              fcmregtk: localStorage.getItem('fcmregtk')
            };

            let imgURL;
            if (arrStoredImages?.length) {
              imgURL = arrStoredImages[0];
              dataToSubmit = { ...dataToSubmit, image: imgURL };
            }
            else if (!state?.isModify && !imgURL) {
              imgURL = `https://gravatar.com/avatar/${moment().unix()}?d=identicon`;
              dataToSubmit = { ...dataToSubmit, image: imgURL };
            }

            if (state?.isModify) {
              console.log('회원정보 수정');
              Axios.post('/api/user/update', dataToSubmit).then(response => {
                setSubmitting(false);//submit 버튼 비활성화를 해제
                if (response.data.success) {
                  //프로필 수정에 성공한 경우
                  //delete Old Image from S3 (oldImageURL)
                  deleteStoredImage(props, [oldImageURL]);
                  props.history.goBack();
                }
                else {
                  console.log(response.data.err.message);
                  alert(response.data.err.message);
                  //프로필 수정에 실패하면 여기서 등록했던 S3 이미지를 제거해야한다.
                  deleteStoredImage(props, arrStoredImages);
                }
              }).catch(err => {
                console.log(err);
                alert(err);
                setSubmitting(false);
              });
            }
            else {
              console.log('회원 가입');

              dispatch(registerUser(dataToSubmit)).then(response => {
                if (response.payload.success) {

                  // 회원가입 성공즉시 로그인
                  dispatch(loginUser(dataToSubmit))
                    .then(response => {
                      if (response.payload.loginSuccess) {
                        window.localStorage.setItem('email', values.email);
                        props.history.push("/");
                        setTimeout(() => {                          
                          // alert('환영합니다! 해커톤허브에서의 해커톤은 초단기 사이드프로젝트 입니다. 누구나 프로젝트 or 아이디어를 올려서 모집된 사람들과 소통하며 자유롭게 원하는 방식으로 프로젝트를 진행할 수 있습니다. 기간이 길어질수록 중간에 좌초될 확률이 올라가니, 최대한 짧고 빠르게 여러번 반복(이터레이션!) 해야겠죠? 여러분의 도전과 실험을 응원합니다! :)');
                          alert('환영합니다! 프로젝트허브는 누구나 프로젝트 or 아이디어를 올려서 사람들을 모집하고 소통하며 프로젝트를 진행할 수 있습니다. 여러분의 도전과 실험을 응원합니다! :)');
                        }, 500);
                      } else {
                        //로그인 실패
                        console.log('로그인 실패 : 일치하는 이메일/비밀번호 정보를 찾을 수 없습니다. 회원가입-로그인 과정에 오류가 발생했습니다 :', response.payload.err.errmsg);
                      }
                    })
                    .catch(err => {
                      //이 경우도 결국 회원가입 과정 중에 문제가 생긴것이므로, 사용자가 가입없이 이 페이지를 벗어날 때 여기서 등록했던 S3 이미지를 제거해야한다.                    
                      deleteStoredImage(props, arrStoredImages);
                      console.log('로그인 실패 : 일치하는 이메일/비밀번호 정보가 없습니다. 회원가입-로그인 과정에 오류가 발생했습니다 :', err)
                    });

                } else {
                  //회원가입 실패
                  alert(response.payload.err.errmsg);
                  console.log(response.payload.err.errmsg);
                  //가입에 실패하면 사용자가 가입없이 이 페이지를 벗어날 때 여기서 등록했던 S3 이미지를 제거해야한다.
                  deleteStoredImage(props, arrStoredImages);
                }
              })

              setSubmitting(false);
            }

          }).catch(err => {
            console.log('이미지 업로드 실패 : ' + err);
            alert('이미지 업로드 실패 : ' + err);
            setSubmitting(false);
          });

        }, 500);

      }}
    >
      {props2 => {
        const {
          values,
          touched,
          errors,
          dirty,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
        } = props2;
        return (
          <div className="page">
            <h2>회원가입</h2>
            <MyForm {...formItemLayout} onSubmit={handleSubmit} >

              {/* DropZone */}
              <FileUpload refreshFunction={updateImages} isProfile={true} imgSrc={state?.image} />

              {(state?.isModify || !state?.name) && <Form.Item required label="이름">
                <Input
                  id="name"
                  placeholder="이름을 입력해주세요"
                  type="text"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.name && touched.name ? 'text-input error' : 'text-input'
                  }
                />
                {errors.name && touched.name && (
                  <div className="input-feedback">{errors.name}</div>
                )}
              </Form.Item>}

              {!state?.email && <Form.Item required label="Email" hasFeedback validateStatus={errors.email && touched.email ? "error" : 'success'}>
                <Input
                  id="email"
                  placeholder="이메일을 입력해주세요"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.email && touched.email ? 'text-input error' : 'text-input'
                  }
                />
                {errors.email && touched.email && (
                  <div className="input-feedback">{errors.email}</div>
                )}
              </Form.Item>}

              {/**
               * 간편 로그인 유저인 경우 비밀번호가 자동생성된 상황이므로 비번 입력창 생략 
               * TODO : 간편로그인을 추가하면 아래 로직에도 추가해야함 */}
              {(state?.loginType != 'google.com' && (state?.isModify || !state?.password)) && <Form.Item required={!state?.isModify} label="비밀번호" hasFeedback validateStatus={errors.password && touched.password ? "error" : 'success'}>
                <Input
                  id="password"
                  placeholder="비밀번호(6자리이상)"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.password && touched.password ? 'text-input error' : 'text-input'
                  }
                />
                {errors.password && touched.password && (
                  <div className="input-feedback">{errors.password}</div>
                )}
              </Form.Item>}

              {(state?.loginType != 'google.com' && (state?.isModify || !state?.password)) && <Form.Item required={!state?.isModify} label="비밀번호 확인" hasFeedback>
                <Input
                  id="confirmPassword"
                  placeholder="비밀번호 확인"
                  type="password"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.confirmPassword && touched.confirmPassword ? 'text-input error' : 'text-input'
                  }
                />
                {errors.confirmPassword && touched.confirmPassword && (
                  <div className="input-feedback">{errors.confirmPassword}</div>
                )}
              </Form.Item>}

              {(state?.isModify || !state?.description) && <Form.Item label="소개">
                <Input
                  id="description"
                  placeholder="ex)개발(N년차),기획(공부중).잘부탁드립니다!"
                  type="text"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.description && touched.description ? 'text-input error' : 'text-input'
                  }
                />
                {errors.description && touched.description && (
                  <div className="input-feedback">{errors.description}</div>
                )}
              </Form.Item>}

              {/* {(state?.isModify || !state?.phone) && <Form.Item required label="전화번호">
                <Input
                  id="phone"
                  placeholder="010-1234-5678"
                  type="text"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={
                    errors.phone && touched.phone ? 'text-input error' : 'text-input'
                  }
                />
                {errors.phone && touched.phone && (
                  <div className="input-feedback">{errors.phone}</div>
                )}
              </Form.Item>} */}

              <p>
                *<a href="/terms">이용약관</a>을 확인하였으며 이에 동의합니다.
              </p>
              <Button style={{ width: '100%' }} onClick={
                  ()=>{
                    //console.log('click 회원가입');
                    handleSubmit();
                  }
                } type="primary" disabled={isSubmitting}>
                {state?.isModify ? '수정하기' : '가입하기'}
              </Button>
            </MyForm>
          </div>
        );
      }}
    </Formik>
  );
};


export default RegisterPage
